import { Injectable } from "@angular/core";
import { CustomerMapping } from '../mappings/customer-result.mapping';
import { ICustomerResultModel } from "../models/customer/customer-result.model";
import { ApplicationContextService } from "../services/application-context.service";
import { AddressMapping } from "../mappings/address.mapping";
import { ISavedAddressModel } from "../models/saved-address/saved-address.model";
import { PaymentMapping } from "../mappings/payment.mapping";
import { CustomerDetailsService } from "./customer-details.service";
import { IJcontrolCustomerCreationModel } from "../models/legacy-info/jcontrol-customer-creation.model";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationModalComponent } from "../confirmation/confirmation-modal.component";
import { IShippingModel } from "../models/shipping/shipping.model";
import { ICustomerCreateModel } from "../models/customer/customer-create.model";
import { ICustomerSummaryModel } from "../models/customer/customer-summary.model";
import { CustomerSummaryMapping } from "../mappings/customer-summary.mapping";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { IGarageVehicleModel } from "../models/garage/garage-vehicle.model";
import { IProductResultResponseModel } from "../models/product/response/products-result-response.model";


@Injectable()
export class FrameCommunicationService {

    private mapping: CustomerMapping;
    private customerSummaryMapping: CustomerSummaryMapping;
    private addressMapping: AddressMapping;
    private paymentMapping: PaymentMapping;
    constructor(
        private context: ApplicationContextService,
        private customer: CustomerDetailsService,
        public modalService: NgbModal,
    ) {
        this.mapping = new CustomerMapping(context);
        this.addressMapping = new AddressMapping();
        this.paymentMapping = new PaymentMapping();
        this.customerSummaryMapping = new CustomerSummaryMapping();
    }

    public doesCustomerExistInJcontrol = (customer: ICustomerResultModel | ICustomerSummaryModel): boolean => {

        if(!customer.legacyInfo){
            return false;
        }

        let legacyId = this.mapping.toJControlCustomerLegacyId(customer.legacyInfo);
        console.log(legacyId);

        if (!legacyId) {
            return false;
        }

        return true;
    }


    public postCustomerToParent = (customer: ICustomerResultModel, getJcontrolCustomerCreationData: boolean): boolean => {

        let dto = this.mapping.toJControlCustomerMessageModel(customer, 'addCustomerToSession');

        try {

            //if customer has no legacy data that means they do not exist internally(on jcontrol)
            //so we need to get the data required to create them on jcontrol otherwise we cannot create order, picks etc...
            //once we have that data we can include it in the post up to the parent jcontrol frame

            if (getJcontrolCustomerCreationData) {
                this.customer.getJcontrolCustomerCreationData(customer.id)
                    .subscribe((data: IJcontrolCustomerCreationModel) => {
                        dto.createCustomerData = data;
                        window.parent.postMessage(dto, '*');
                    },
                        (error:any) => {
                            alert('An error occured when retrieving the customers info via getJcontrolCustomerCreationData in order to create then in jcontrol. \n\n The customer id is ' + customer.id + '. \n\n Please raise a request on ithelpdesk.sngbarratt.com and include this error message.') //todo
                        })

            } else {

                //get the customers garage
                this.customer.getCustomerVehicles(customer.id)
                    .subscribe((garage: any) => {
                        if(garage && garage.total && garage.data){
                            dto.garageVehicles = garage.data;
                        }else{
                            dto.garageVehicles = [];
                        }
                        window.parent.postMessage(dto, '*');
                    },
                        (error:any) => {
                            dto.garageVehicles = [];
                            window.parent.postMessage(dto, '*');
                        })

            }

            return true;

        }
        catch (e) {
            return false;
        }

    }

    public postNewCustomerToParent = (customer: ICustomerSummaryModel, getJcontrolCustomerCreationData: boolean): boolean => {

        let dto = this.customerSummaryMapping.toJControlNewCustomerMessageModel(customer, 'addCustomerToSession');

        try {

            //if customer has no legacy data that means they do not exist internally(on jcontrol)
            //so we need to get the data required to create them on jcontrol otherwise we cannot create order, picks etc...
            //once we have that data we can include it in the post up to the parent jcontrol frame

            if (getJcontrolCustomerCreationData) {

                this.customer.getJcontrolCustomerCreationData(customer.id)
                    .subscribe((data: IJcontrolCustomerCreationModel) => {
                        dto.createCustomerData = data;
                        window.parent.postMessage(dto, '*');
                    },
                        (error) => {
                            alert('An error occured when retrieving the customers info via getJcontrolCustomerCreationData in order to create then in jcontrol. \n\n The customer id is ' + customer.id + '. \n\n Please raise a request on ithelpdesk.sngbarratt.com and include this error message.') //todo
                        })

            } else {
                window.parent.postMessage(dto, '*');
            }

            return true;

        }
        catch (e) {
            return false;
        }

    }

    updateCustomerPaymentMethodInParent(paymentData: any) {

        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let updatedPaymentMethod = this.paymentMapping.updateJControlPaymentMethodModel(paymentData);

        try {
            window.parent.postMessage(updatedPaymentMethod, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public postAddressToParent = (addressType: string, address: ISavedAddressModel, companyName?: string, saveNewAddress?: boolean): boolean => {

        if (this.context.isApplicationEmbedded() == false) {
            return false;
        }

        var addressDto = this.addressMapping.toJControlAddressMessageModel('addAddressToOrder', addressType, address, companyName, saveNewAddress);

        try {
            window.parent.postMessage(addressDto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public postShippingDetailsToParent = (shippingData: IShippingModel): boolean => {

        if (this.context.isApplicationEmbedded() == false) {
            return false;
        }

        let shippingDetailsDto = {
            messageType: 'addShippingInfoFromCustMan',
            shippingData: shippingData,
        }

        try {
            window.parent.postMessage(shippingDetailsDto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public updateParentFrameJwt = (jwt: string, jwtRefreshToken: string): boolean => {
        //if our jwt is refreshed in Cust Man, we need to give the new jwt to the parent frame to save otherwise when the parent frames original jwt expires it will fail to refresh within the parent frame

        let message = {
            messageType: 'updateJwt',
            jwt: jwt,
            jwtRefreshToken: jwtRefreshToken
        }

        try {
            window.parent.postMessage(message, '*')
            return true;
        }
        catch (e) {
            return false;
        }

    }

    public isCrossFrameMessageAllowed = (msg: any, acceptedOrigins: string[]): boolean => {

        if (!msg || !msg.origin || !msg.data) {
            return false;
        }

        for (let i = 0; i <= acceptedOrigins.length; i++) {
            if (msg.origin.indexOf(acceptedOrigins[i]) == -1) {
                return true;
            }
        }

        return false
    }

    public navigateToParentPage(pagePath: string) {
        let dto = {
            path: pagePath,
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public continueWithParentCheckout() {
        let dto = {
            messageType: 'continueWithCheckout',
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public postAppHeightToParent(newHeight:number|undefined, application?: string) {

        try {
            if (!newHeight) {
                newHeight = 750; //750 is a fallback
            }

            window.parent.postMessage({
                type: application,
                height: newHeight
            }, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public updateDefaultWebDataFromCustMan(tab: string, model: any) {
        let dto = {
            data: {},
            messageType: '',
        };

        if (tab === 'contact') {
            dto.messageType = 'updateCustomerDetails';
            dto.data = {
                firstName: model.firstName,
                lastName: model.lastName,
                emailAddress: model.emailAddress,
                phoneNumber: model.telephoneNumber != null ? model.telephoneNumber : model.mobileNumber
            }
        }

        if (tab === 'address') {
            dto.messageType = 'updateCustomerDetails';
            dto.data = {
                shippingAddress: {
                    id: model.id,
                    displayName: undefined,
                    default: model.details.isShipToDefault,
                    name: model.details.name,
                    phoneNumber: model.details.contactNumber,
                    addressLine1: model.details.addressLine1,
                    addressLine2: model.details.addressLine2,
                    townCity: model.details.townCity,
                    countyState: model.details.countyState,
                    postalCode: model.details.postalCode,
                    country: model.details.countryName,
                    countryCode: model.details.countryCode
                }
            }
        }

        if (tab === 'shipping') {
            dto.messageType = 'updateCustomerDetails';
            dto.data = {
                shippingAddress: {
                    id: undefined,
                    displayName: undefined,
                    default: true,
                    name: model.name,
                    phoneNumber: model.contactNumber,
                    addressLine1: model.addressLine1,
                    addressLine2: model.addressLine2,
                    townCity: model.townCity,
                    countyState: model.countyState,
                    postalCode: model.postalCode,
                    country: model.countryName,
                    countryCode: model.countryCode
                }
            }
        }

        if (tab === 'vehicle') {
            dto.messageType = 'updateCustomerGarageDetails';
            dto.data = {
                displayName: model.displayName, 
                webGuid: model.webGuid ? model.webGuid : undefined, 
                year: model.year, 
                engineNumber: model.engineNumber, 
                chassisNumber: model.chassisNumber, 
                vin: model.vehicleIdentificationNumber, 
                notes: model.notes, 
                registrationNumber: model.registrationNumber, 
                isDefault: model.isDefault,
                vehicle: model.vehicle,
                defaultStatusChanged: model.defaultStatusChanged ? model.defaultStatusChanged : undefined
            }
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    updateDefaultCustomerAddressInJControl(tab: string, model: any) {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            message: 'updateDefaultAddressInLocalStorage',
            data: {},
            defaults: {}
        }

        if (tab === 'address') {
            // model.details comes from edit address in address tab
            if (model.details) {
                dto.data = {
                    addressLine1: model.details.addressLine1,
                    addressLine2: model.details.addressLine2,
                    contactName: model.details.name,
                    countryName: model.details.countryName,
                    country_Code: model.details.countryCode,
                    countyState: model.details.countyState,
                    id: model.id,
                    isVerified: model.details.isVerified,
                    postalCode: model.details.postalCode,
                    townCity: model.details.townCity,
                    contactTelephone: model.details.contactNumber
                }
                dto.defaults = {
                    isBillToDefault: model.details.isBillToDefault,
                    isShipToDefault: model.details.isShipToDefault
                }
            }

            // model.address comes from adding a new address in address tab
            if (model.address) {
                dto.data = {
                    addressLine1: model.address.addressLine1,
                    addressLine2: model.address.addressLine2,
                    contactName: model.address.name,
                    countryName: model.address.countryName,
                    country_Code: model.address.countryCode,
                    countyState: model.address.countyState,
                    id: model.customerId,
                    isVerified: model.address.isVerified,
                    postalCode: model.address.postalCode,
                    townCity: model.address.townCity,
                    contactTelephone: model.address.contactNumber
                }
                dto.defaults = {
                    isBillToDefault: model.address.isBillToDefault,
                    isShipToDefault: model.address.isShipToDefault
                }
            }
        }

        if (tab === 'shipping') {
            // model comes from creating/editing default ship to address in shipping tab
            if (model) {
                dto.data = {
                    addressLine1: model.addressLine1,
                    addressLine2: model.addressLine2,
                    country_Code: model.countryCode,
                    countryName: model.countryName,
                    countyState: model.countyState,
                    id: model.id,
                    isVerified: model.isVerified,
                    contactName: model.name,
                    postalCode: model.postalCode,
                    townCity: model.townCity
                }
                dto.defaults = {
                    isBillToDefault: false,
                    isShipToDefault: true
                }
            }
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }     
    }

    updateCustomerDefaultShippingMethodInJControl(defaultShippingMethodId: string) {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            fieldToUpdate: 'defaultShippingMethod',
            defaultShippingMethod: {id: defaultShippingMethodId}
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    updateCustomerDefaultContactTelephoneNumber(number: string) {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            fieldToUpdate: 'defaultTelephoneNumber',
            telephoneNumber: number
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    updateCustomerDiscountLevelInJControl(discountLevel: ILookUpType) {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            message: 'updateCustomerDiscountLevelFromCustMan',
            newTradingLevel: {
                tradingLevelName: discountLevel.name,
                tradingLevelId: ''
            }
        }

        if (discountLevel.code === 'RET') {
            dto.newTradingLevel.tradingLevelId = '0';
        } else if (discountLevel.code === 'LV1') {
            dto.newTradingLevel.tradingLevelId = '1';
        } else if (discountLevel.code === 'LV2') {
            dto.newTradingLevel.tradingLevelId = '3';
        } else if (discountLevel.code === 'LV3') {
            dto.newTradingLevel.tradingLevelId = '5';
        } else if (discountLevel.code === 'LV4') {
            dto.newTradingLevel.tradingLevelId = '7';
        } else if (discountLevel.code === 'LV5') {
            dto.newTradingLevel.tradingLevelId = '9';
        } else if (discountLevel.code === 'LV6') {
            dto.newTradingLevel.tradingLevelId = '11';
        } else if (discountLevel.code === 'CST') {
            dto.newTradingLevel.tradingLevelId = '13';
        } else { // defaults to 'Retail'
            dto.newTradingLevel.tradingLevelId = '0';
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    updateCustomerGarageVehiclesInJControl(garageVehicles: IGarageVehicleModel[]) {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            fieldToUpdate: 'garageVehicles',
            garageVehicles: garageVehicles
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    public disableCustomerManagement() {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            message: 'disableCustomerManagement'
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }

    // customer: ICustomerResultModel, getJcontrolCustomerCreationData: boolean: 
    public postProductToParent = (product: IProductResultResponseModel): boolean => {
        if (this.context.isApplicationEmbedded() == false) {
            return false
        }

        let dto = {
            messageType: 'sendProductDetailsToJControl',
            productId: product.id
        }

        try {
            window.parent.postMessage(dto, '*');
            return true;
        }
        catch (e) {
            return false;
        }
    }
}